import React from 'react';

interface Props {
  value: any;
  type?: 'text' | 'password';
  placeholder?: string;
  className?: string;
  onChange: (value: any) => void;
}

function Input(props: Props = { value: '', type: 'text', onChange: () => { } }) {
  return <input
    type={props.type}
    placeholder={props.placeholder}
    value={props.value}
    onChange={event => props.onChange(event.target.value)}
    className={"border p-1 rounded " + (props.className ?? '') }
  />;
}

export default Input;